var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "flex flex-col gap-y-8" },
    [
      _c(
        "JadeBox",
        [
          _c(
            "div",
            { staticClass: "flex justify-between px-5 py-5" },
            [
              _c("JadeDisplayItem", {
                attrs: {
                  alignment: "left",
                  label: _vm.$t("amount"),
                  support: _vm.$t("created-at", {
                    formattedDate: _vm.dateFormated,
                  }),
                  value: _vm.amount,
                },
              }),
              _c("JadeDisplayItem", {
                attrs: {
                  alignment: "right",
                  label: _vm.$t("status"),
                  value: { variant: _vm.statusVariant, text: _vm.statusLabel },
                },
              }),
            ],
            1
          ),
          _c("div", { staticClass: "px-5" }, [_c("JadeDivider")], 1),
          _c("JadeListItem", {
            attrs: {
              label: _vm.$t("chargebackId"),
              trailing: _vm.chargebackId,
            },
          }),
          _c("div", { staticClass: "px-5" }, [_c("JadeDivider")], 1),
          _c("JadeListItem", {
            attrs: {
              label: _vm.$t("reasonDescription"),
              trailing: _vm.reasonDescription,
            },
          }),
          _c("div", { staticClass: "px-5" }, [_c("JadeDivider")], 1),
          _c("JadeListItem", {
            attrs: {
              label: _vm.$t("customer-name"),
              trailing: _vm.cardHolderName,
            },
          }),
          _c("div", { staticClass: "px-5" }, [_c("JadeDivider")], 1),
          _c("JadeListItem", {
            attrs: {
              label: _vm.$t("document-number"),
              trailing: _vm.customerDocument,
            },
          }),
          _c("div", { staticClass: "px-5" }, [_c("JadeDivider")], 1),
          _c("JadeListItem", {
            attrs: { label: _vm.$t("email"), trailing: _vm.email },
          }),
          _c("div", { staticClass: "mb-2" }),
        ],
        1
      ),
      _c(
        "JadeBox",
        [
          _c("jade-group-header", { attrs: { title: _vm.$t("payment-data") } }),
          _c("JadeListItem", {
            attrs: {
              label: _vm.$t("payment-method"),
              trailing: _vm.$t("credit-card"),
            },
          }),
          _c("div", { staticClass: "px-5" }, [_c("JadeDivider")], 1),
          _c("JadeListItem", {
            attrs: { label: _vm.$t("card-brand") },
            scopedSlots: _vm._u([
              {
                key: "trailing",
                fn: function () {
                  return [_c("jade-brand", { attrs: { use: _vm.brandImage } })]
                },
                proxy: true,
              },
            ]),
          }),
          _c("div", { staticClass: "px-5" }, [_c("JadeDivider")], 1),
          _c("JadeListItem", {
            attrs: { label: _vm.$t("card-number"), trailing: _vm.cardNumber },
          }),
          _c("div", { staticClass: "px-5" }, [_c("JadeDivider")], 1),
          _c("JadeListItem", {
            attrs: {
              label: _vm.$t("card-holder-name"),
              trailing: _vm.cardHolderName,
            },
          }),
          _c("div", { staticClass: "mb-2" }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }